import * as React from "react";
import type { SVGProps } from "react";
const SvgFireplace = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 21h18m-1-3H4v-7.5c0-2.667 1.6-8 8-8s8 5.333 8 8zM11.401 8c.677.98 1.599 3.5 1.599 5 0 0 .698.47 2-2 .483.686.695 2.882.463 4.059-.29 1.47-1.45 2.941-3.482 2.941-2.03 0-3.481-1.736-3.481-3.235 0-1.765 1.16-2.942 2.03-4.118.697-.941.871-2.157.871-2.647"
    />
  </svg>
);
export default SvgFireplace;
